import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export function MaskedLines({
    lines,
    delay = 0,
    stagger = 0.12,
    duration = 0.95,
    inView = false,
    className = "",
    lineClassName = "",
}) {
    const variants = {
        hidden: { y: "115%" },
        visible: { y: "0%" },
    };
    return (
        <div className={className}>
            {lines.map((line, i) => (
                <motion.span
                    key={i}
                    className="block overflow-hidden pb-[0.1em] -mb-[0.1em]"
                    initial="hidden"
                    {...(inView
                        ? {
                              whileInView: "visible",
                              viewport: { once: true, amount: 0.4 },
                          }
                        : { animate: "visible" })}
                >
                    <motion.span
                        className={`block will-change-transform ${lineClassName}`}
                        variants={variants}
                        transition={{
                            duration,
                            ease: EASE,
                            delay: delay + i * stagger,
                        }}
                    >
                        {line}
                    </motion.span>
                </motion.span>
            ))}
        </div>
    );
}

export default MaskedLines;